<template>
  <div>
    <div style="clear:both"></div>
    <one-brand-display ></one-brand-display>
    <two-sightseeing title="观光农业"></two-sightseeing>
    <three-server></three-server>
    <five-links></five-links>
  </div>
</template>

<script>
import OneBrandDisplay from './content/OneBrandDisplay.vue'
import TwoSightseeing from './content/TwoSightseeing.vue'
import ThreeServer from './content/ThreeServer.vue'
import FiveLinks from './content/FiveLinks.vue'
export default {
  components: { OneBrandDisplay, TwoSightseeing, ThreeServer, FiveLinks }
}
</script>
